import * as React from "react";
import styled from "styled-components";

interface RightTriangleInfoBlockProps {}

const RightTriangleInfoBlock = (props: RightTriangleInfoBlockProps) => {
  return (
    <JPKInfoWrapper>
      <JPKInfoButtonWrapper>
        <BlueTriangleWrapper/>
        <JPKInfoTextWrapper>
          <span>JPK_CIT</span>
          <br/>
          <span>KSeF</span>
          <br/>
          <span>READY</span>
        </JPKInfoTextWrapper>
      </JPKInfoButtonWrapper>
    </JPKInfoWrapper>
  )
}

/** STYLES */

const JPKInfoWrapper = styled.div`
  text-align: center;
  position: fixed;
  z-index: 997;
  top: 40%;
  right: 0;
  /* TELEFON => ZNACZEK ZASŁANIAŁ TEKST SEKCJI, KSEF JEST WIDOCZNY W FUNKCJACH */
  @media (max-width: 600px) {
    display: none;
  }
`;

const JPKInfoButtonWrapper = styled.div`
  color: #fff;
  font-weight: 700;
  text-transform: uppercase;
`;

const BlueTriangleWrapper = styled.div`
  background-color: #3190E7;
  box-shadow: 7px 6px 7px 0 rgba(0,0,0,.35);
  transform: rotate(45deg);
  position: absolute;
  width: 195px;
  border-radius: 15px;
  right: -90px;
  height: 200px;
`;

const JPKInfoTextWrapper = styled.div`
  font-size: 18px;
  margin-top: -4px
  cursor: default !important;
  font-size: 15px;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 68px;
  width: 105px;
`;

export default RightTriangleInfoBlock



// WEBPACK FOOTER //
// ./src/layouts/right-triangle-info-block/right-triangle-info-block.tsx